module.exports = __webpack_public_path__ + "img/intropage-bacterial-dna-icon.2dd18312.svg";